import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';

import BannerHero from '../../assets/smart_banner_hero.png';
import {isMobileDevice, useBrand} from '../../helpers';
import {
    mobileMediaQuery,
    notWebMediaQuery,
    useIsWeb,
    webMediaQuery,
} from '../../styles';
import {ReactComponent as CloseIcon} from '../../assets/close.svg';

const Container = styled.div`
    position: fixed;
    display: flex;

    align-items: center;
    width: 100%;
    height: 94px;
    z-index: 105;
    padding: 0px 25px;
    box-sizing: border-box;
    background: linear-gradient(90deg, #f55a86 0%, #ec098c 100%);

    & > div {
        svg {
            g {
                fill: #fff;
            }
        }
    }

    ${props => (props.isWeb ? 'bottom: 0px;' : 'top: 0px;')}
    ${props =>
        props.brand === 'dkids' &&
        `background: url(${require('../../assets/dkids/smart-banner-bg.png')}) no-repeat;`}

    ${notWebMediaQuery} {
        height: 68px;
    }
    ${webMediaQuery} {
        background-size: cover;
    }
`;

const Hero = styled.img.attrs(props => ({
    src: BannerHero,
}))`
    object-fit: contain;
    width: 100px;
    height: 100px;
    margin-right: 24px;
    margin-bottom: 40px;
    cursor: pointer;

    ${notWebMediaQuery} {
        width: 50px;
        height: 50px;
        margin-bottom: 0px;
    }
`;

const Text = styled.p`
    color: white;
    margin: auto auto auto 0px;
    font-family: 'AvenirNextRoundedStd';
    font-size: 20px;
    font-weight: 600;
    line-height: 18px;
    text-transform: uppercase;
    margin-right: 16px;

    ${notWebMediaQuery} {
        font-size: 14px;
    }
`;

const TextDownload = styled.span`
    color: white;
    font-family: TTNormsProExtraBlack;
    text-transform: uppercase;
    font-size: 20px;

    ${notWebMediaQuery} {
        flex-direction: column;
        font-size: 14px;
    }
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: row;
    cursor: pointer;
    align-items: center;
    flex: 1;
    height: 100%;

    ${mobileMediaQuery} {
        flex: 1;
        flex-direction: column;
        align-items: flex-start;
        height: 45px;
    }
`;

const Button = styled.div`
    cursor: pointer;
`;

const SmartBanner = ({close}) => {
    const {t} = useTranslation();
    const isWeb = useIsWeb();
    const brand = useBrand();

    useEffect(() => {
        let timeout = setTimeout(() => {
            close();
        }, 15000);
        return () => {
            clearTimeout(timeout);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleRedirectAppStore = () => {
        window.turner_metadata.trackAction.push({
            type: 'interaction',
            data: {
                interaction: 'cnplus|download prompt',
                domain: 'cnplus.com',
                brand: 'cartoon network',
                interactionevent: 1,
            },
        });

        if (isMobileDevice()) {
            window.open('https://cnapp.page.link/85Up', '_blank');
        } else {
            window.open(
                'https://www.cartoonnetwork.com.br/promo/apps',
                '_blank',
            );
        }
    };

    return (
        <Container className="smart-banner" isWeb={isWeb} brand={brand}>
            <Hero width="99px" height="58px" onClick={handleRedirectAppStore} />
            <TextContainer onClick={handleRedirectAppStore}>
                <Text>{t('smartBannerV2.text')}</Text>
                <TextDownload>{t('smartBannerV2.cta')}</TextDownload>
            </TextContainer>
            <Button onClick={close}>
                <CloseIcon />
            </Button>
        </Container>
    );
};

export default SmartBanner;
